/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Error_Step_LimitInputs */



/**
* | output |
* | --- |
* | "The agent reached its limit of steps for one prompt. Ask it to continue." |
*
* @param {Assistant_Error_Step_LimitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_error_step_limit = /** @type {((inputs?: Assistant_Error_Step_LimitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Error_Step_LimitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'agent a atteint sa limite d'étapes pour cette invite. Demandez-lui de continuer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Agent hat die maximale Anzahl an Schritten für eine Eingabeaufforderung erreicht. Bitten Sie ihn, fortzufahren.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'agente ha raggiunto il limite di passaggi per un singolo prompt. Chiedigli di continuare.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Агент выполнил максимальное количество шагов для одного запроса. Попросите его продолжить.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El agente ha alcanzado su límite de pasos para una sola solicitud. Pídele que continúe.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("代理已达到单次提示步骤的上限。请让它继续。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エージェントが1つのプロンプトに対する処理ステップ数の上限に達しました。処理を続行するように指示してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एजेंट ने एक प्रॉम्प्ट के लिए चरणों की सीमा पूरी कर ली है। कृपया इसे जारी रखने के लिए कहें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O agente atingiu o limite de passos para uma solicitação. Peça para ele continuar.")
	return /** @type {LocalizedString} */ ("The agent reached its limit of steps for one prompt. Ask it to continue.")
});